import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

const ButtonArea = ({ vertical, justify, children }) => (
    <StyledArea className="buttonArea" vertical={vertical} justify={justify}>
        {children}
    </StyledArea>
);

ButtonArea.propTypes = {
    children: PropTypes.node.isRequired,
    vertical: PropTypes.bool,
    justify: PropTypes.oneOf(["start", "center", "end"]),
};

ButtonArea.defaultProps = {
    vertical: false,
    justify: "end",
};

export default ButtonArea;

/* Helpers */

const getFlexJustify = (justify) => {
    if (justify === "start" || justify === "end") return `flex-${justify}`;
    return justify;
};

/* Styled Components */

const StyledArea = styled.div`
    display: flex;
    flex-direction: ${(props) => (props.vertical ? "column" : "row")};
    flex-wrap: wrap;
    margin: 0em -0.5em;
    align-items: ${(props) => (props.vertical ? "flex-start" : "center")};
    justify-content: ${(props) => getFlexJustify(props.justify)};
    > * {
        margin: 0.5em;
        width: fit-content;
    }
    @media only screen and (max-width: 421px) {
        justify-items: stretch;
        margin: 0em -0.25em;
        > * {
            margin: 0.25em;
        }
    }
`;
